import {
  Box,
  styled,
  FormControl,
  MuiSelect,
  MenuItem,
} from '@ltvco/refresh-lib/theme';

export const DropdownContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledSelect = styled(MuiSelect)(({ theme }) => ({
  height: '40px',
  borderRadius: '20px !important',
  backgroundColor: theme.palette.common.white,
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  fontWeight: 400,
  '& .MuiSelect-select': {
    padding: '8px 16px',
    paddingRight: '40px !important',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[500],
    borderWidth: '1px',
    borderRadius: '20px !important',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px',
  },
  '& .MuiSelect-icon': {
    right: '12px',
    color: theme.palette.text.primary,
  },
  [theme.breakpoints.down('sm')]: {
    borderRadius: '100px !important',
    '& .MuiSelect-select': {
      padding: '8px 12px',
      paddingRight: '36px !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.disabled,
      borderRadius: '100px !important',
    },
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.action.selected,
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
